/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Add, ArrowDropDown } from "@mui/icons-material";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Autocomplete, Badge, Box, Button, Card, CardContent, Checkbox, FormControl, FormControlLabel, InputAdornment, InputLabel, MenuItem, Modal, Select, TextField, Typography, } from "@mui/material";
import Grid from "@mui/material/Grid";
import Tooltip from '@mui/material/Tooltip';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import axios from "axios";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import BillingModal from "components/displayModel/billingModel";
import { useMaterialUIController } from "context";
import dayjs from 'dayjs';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { appConstants } from "utils/appConstants";
import { convertToTitleCase, formatDateWithCurrentTimeForPickDate, getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { SaveInvoice, UpdateInvoice, getInvoiceDetailsByID, getItemsForInvoice, getQuotationsForInvoice } from "utils/invoiceAPI";
import { getContactsForQuotation } from "utils/quotationAPI";
import useFeatureAccess from "utils/useFeatureAccess";
import { getFileType } from "utils/generic";
import { loadingAction } from "ReduxReducers/loadingReducer";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import { paymentTermsOptions } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import { AllKeysHaveValue } from "utils/generic";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import useTableStyles from "styles/customStyleItemTable";
import { memo } from "react";
import { getCurrencyValue } from "utils/generic";
import { calculateAmounts } from "utils/generic";
import { calculatePrice } from "utils/generic";
import { getCurrencyCode } from "utils/api";
import { formatCurrencyAUD } from "utils/formatCurrency";
import { formatNumberWithCommas } from "utils/formatCurrency";

const SCREEN_NAME = "Invoices";
let SCREEN_RIGHT;
const pdfStyle = {
  boxShadow: 24,
  p: 4,
  top: "50%",
  left: "50%",
  width: "90%",
  height: "90%x",
  position: "absolute",
  border: "2px solid #000",
  bgcolor: "background.paper",
  transform: "translate(-50%, -50%)",
};
const tableCardStyle = { width: "100%", }
let routePath = "";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
function handleApiResponse({
  isUpdate,
  values,
  setOpen,
  showResMsg,
  navigate,
  handleSoftDismisal,
  setShowBillingModal,
  dispatch,
  redirectToOutside,
  InvoiceID,
}) {

  const apiFunction = isUpdate ? UpdateInvoice : SaveInvoice;

  apiFunction(values, (data) => {
    console.log("data", data)
    if (data?.Result_Status) {
      setOpen(false);

      let targetRoute;
      if (redirectToOutside === 'redirectToItemWhenSave') {
        navigate(`/items/addItems?new=invoice&id=${data.Result_Output._id}`)
      }
      else if (redirectToOutside === 'redirectToEditItemWhenSave') {
        let ItemIdForItemEdit = sessionStorage.getItem("ItemIdForItemEdit")
        console.log("ItemIdForItemEdit", ItemIdForItemEdit)
        sessionStorage.removeItem("ItemIdForItemEdit");
        navigate(`/items/editItem/itemid=${ItemIdForItemEdit}?source=invoice&id=${data.Result_Output._id || ''}`);

      }
      else {
        showResMsg(data.Result_Message, 2000, data.Result_Status, navigate, '/invoices');

      }

      navigate(targetRoute);
    } else if (data.Result_Message === "ALREADY_EXIST_PO") {
      handleSoftDismisal();
    } else {
      if (data.Result_Output === "NO AVAILABLE CREDITS") {
        setShowBillingModal(true);
      }
      showResMsg(data.Result_Message, 2000, data.Result_Status);
    }
  }, dispatch);
}


function AddInvoice() {
  //Starts here change the pagination text Rows per page to Record per page
  let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName("span")[0].textContent = "Records Per Page";
  }  //ends here change the pagination text Rows per page to Record per page
  const featureAccess = useFeatureAccess();
  const customStyles = useTableStyles();

  let navigate = useNavigate();
  let dispatch = useDispatch();
  const { id: InvoiceID } = useParams();
  const showAddNewCustomer = InvoiceID === undefined;
  let type = new URLSearchParams(window.location.search).get('type');
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const [token, setToken] = useState(sessionStorage.getItem("TOKEN"));
  const [invoiceNoErr, setInvoiceNoErr] = useState(false);
  const [contactNameErr, setContactNameErr] = useState(false);
  const [contactDetails, setContactDetails] = useState([]);
  const [quotationDetails, setQuotationDetails] = useState([]);
  const [screenName, setScreenName] = useState("Add New Invoice");
  const [typeQuotation, setTypeQuotation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSendEmailBtn, setShowSendEmailBtn] = useState(false);
  const [showItemAndDocumentSection, setShowItemAndDocumentSection] = useState(false);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [itemsDetails, setItemsDetails] = useState([]);
  const [masterItemDetails, setMasterItemDetails] = useState([]);
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemID: "", itemName: "", itemPrice: "", itemDescription: "", categoryCodeName: "", itemQuantity: "", gst: "",
      discountType: "None", discountValue: "", discountAmount: 0, totalItemPrice: 0,
    },
  ]);
  const [quotationLoaded, setQuotationLoaded] = useState(false);

  const [usedRetentionAmount, setUsedRetentionAmount] = useState(0);
  const [finalise, setFinalise] = useState(false)
  const [scheduleRetention, setScheduleRetention] = useState(false);
  const [retentionItemValues, setRetentionItemValues] = useState([]);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const [selectedFileType, setSelectedFileType] = useState('');
  const [showInvoicePaymentLink, setShowInvoicePaymentLink] = useState(false);
  const [expanded, setExpanded] = useState(false);
  //Used for Modal Email Template 
  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "Invoices",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });

  const [values, setValues] = useState({
    token: token,
    businessUserID: loginDetails?.businessUserID,
    invoiceID: undefined,
    userID: loginDetails?._id,
    invoiceNumber: 'Auto Generated',
    invoiceType: "Direct",
    contactID: '',
    quotationID: '',
    purchaseOrderNumber: '',
    invoiceDate: new Date(new Date() - (new Date().getTimezoneOffset() * 60000)),
    dueDate: new Date(new Date() - (new Date().getTimezoneOffset() * 60000)),
    dueUpto: 'Same Day',
    invoiceStatus: 'Unpaid',
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    totalGSTAmount: 0,
    finalAmount: 0,
    paymentInstruction: '',
    documentName: "",
    sendEmailFlag: false,
  })
  // const [file, setFile] = useState(null);
  const [quoDocuments, setDocuments] = useState([]);
  const [currencyCode, setCurrencyCode] = useState("");

  const itemRowValuesRef = useRef(itemRowValues);
  const retentionItemValuesRef = useRef(retentionItemValues);

  useEffect(() => {
    var element = document.getElementsByTagName('fieldset');
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    var disabledval = document.querySelectorAll('.Mui-disabled');
    var dropicons = document.querySelectorAll('.MuiInputBase-root');
    for (let i = 0; i < element.length; i++) {

      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < disabledval.length; i++) {
      var usevalue = disabledval[i].getElementsByTagName('input');

      if (usevalue.length > 0) {
        if (darkMode) {
          usevalue[0].style.setProperty("-webkit-text-fill-color", "white", "important");

        } else {
          usevalue[0].style.removeProperty("-webkit-text-fill-color");
        }
      }
    }

    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName('svg');
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "fill:");
        }
      }
    }
  }, [itemRowValues, expanded])


  useEffect(() => {


    console.log("itemRowValues changed", itemRowValues);
    console.log("itemRowValuesRef current", itemRowValuesRef.current);
    if (JSON.stringify(itemRowValues) !== JSON.stringify(itemRowValuesRef.current)) {
      console.log("itemRowValues actually changed");
      itemRowValuesRef.current = itemRowValues;
      calculateDiscountAmount(itemRowValues);
    }
    addNewRowInList(itemRowValues);
    const filtered = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== undefined);
    if (filtered.length > 0) {
      setShowSendEmailBtn(filtered.every(row => row.itemID && row.itemPrice && row.itemQuantity))
    } else {
      setShowSendEmailBtn(false);
    }
  }, [itemRowValues]);





  useEffect(() => {
    if (values.invoiceType === "Through Quotation" && values.quotationID) {
      setTypeQuotation(true);
    } else {
      setTypeQuotation(false);
    }
  }, [values.invoiceType, values.quotationID])

  useEffect(() => {
    const paramValue = new URLSearchParams(window.location.search).get('status');

    switch (paramValue) {
      case "debt":
        routePath = '/debts';
        break;
      default:
        routePath = '/invoices';
        break;
    }

  }, [dispatch,]);



  const fetchData = async () => {
    try {
      setScreenName(InvoiceID ? (type !== "clone" ? "Edit Invoice" : "Clone Invoice ") : "Add New Invoice");
      setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));

      await Promise.all([
        getRight(),
        LoadInitialData(),
        fetchCurrencyValue()
      ])
      FetchQuotationDetailsByID();

    } catch (error) {
      console.error("Error in useEffect:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch,]);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
  }

  let fetchCurrencyValue = async () => {
    await getCurrencyCode({ businessUserID: values.businessUserID }, (data => {
      if (data.Result_Status) {
        setCurrencyCode(data.Result_Output)
      }
    }), dispatch);
  }

  const LoadInitialData = async () => {
    try {
      const [customerList, quotationList] = await Promise.all([
        new Promise((resolve, reject) => {
          getContactsForQuotation({ businessUserID: values.businessUserID }, resolve, dispatch)
        }),
        new Promise((resolve, reject) => {
          getQuotationsForInvoice({ businessUserID: values.businessUserID, invoiceID: InvoiceID }, resolve, dispatch);
        })
      ]);
      if (customerList.Result_Output.length > 0) {
        setContactDetails(customerList.Result_Output);
      }
      if (quotationList.Result_Status) {
        // console.log("setQuotationDetails", quotationList.Result_Output)
        setQuotationDetails(quotationList.Result_Output);
      }
    } catch (error) {
      console.error("Error getting Invoice Details: ", error.message)
    }
  };
  const FetchQuotationDetailsByID = async () => {
    console.log("FetchQuotationDetailsByID called")
    try {
      let detailsPromise;
      let itemsPromise;
      itemsPromise = new Promise((resolve, reject) => {
        getItemsForInvoice(values, data => {
          if (data.Result_Output.length > 0) {
            setItemsDetails(data.Result_Output);
            setMasterItemDetails(data.Result_Output);
            resolve();
          } else {
            reject(new Error("No items found for quotation"));
          }
        }, dispatch);
      });

      if (InvoiceID) {
        values.invoiceID = InvoiceID;
        itemsPromise = new Promise((resolve, reject) => {
          getItemsForInvoice(values, data => {
            if (data.Result_Output.length > 0) {
              setItemsDetails(data.Result_Output);
              setMasterItemDetails(data.Result_Output);
              resolve();
            } else {
              reject(new Error("No items found for quotation"));
            }
          }, dispatch);
        });
        // Fetch quotation details fetchQuotationDetailsByID
        detailsPromise = new Promise((resolve, reject) => {
          getInvoiceDetailsByID(values, (data) => {
            // FetchQuotationDetailsByID()
            let result = data.Result_Output[0];
            console.log("getInvoiceDetailsByID result", result)
            if (data.Result_Status) {
              setFinalise((result?.emailSent > 0) ? true : false);
              setValues({ ...values, ...result, });
              const apiItems = result.items || [];

              setQuotationLoaded(true);

              if (result.items?.length > 0) {
                setItemRowValues([
                  ...apiItems,
                  { ...EMPTY_ITEM_ROW }
                ]);
              } else {
                setItemRowValues([{ ...EMPTY_ITEM_ROW }]);
              }

              if (result.invoiceDocuments?.length > 0) {
                setDocuments(result.invoiceDocuments);
              }
              // setShowItemAndDocumentSection(true);
              resolve();

              if (result.retentions?.length > 0) {
                setScheduleRetention(true);
                setRetentionItemValues(result.retentions);
              }
              setShowInvoicePaymentLink(result.showPaymentSection);
            } else {
              showResMsg(data.Result_Message, 2000, false);
              navigate('/invoices')
              reject(new Error("No invoice details found"));
            }
          }, dispatch);
        });

      } else {
        dispatch(loadingAction(false))
      }
      await Promise.all([itemsPromise, detailsPromise]);
    }
    catch (error) {
      console.error("Error in FetchQuotationDetailsByID:", error);
      // Handle errors as needed
    }
  }
  // const FetchQuotationDetailsByID = async () => {

  //   try {
  //     const itemsPromise = new Promise((resolve, reject) => {
  //       getItemsForInvoice(values, data => {
  //         if (data.Result_Output.length > 0) {
  //           setItemsDetails(data.Result_Output);
  //           setMasterItemDetails(data.Result_Output);
  //           resolve();
  //         } else {
  //           reject(new Error("No items found for quotation"));
  //         }
  //       }, dispatch);
  //     });
  //     let detailsPromise;
  //     if (InvoiceID) {
  //       values.invoiceID = InvoiceID;

  //       // Fetch quotation details
  //       detailsPromise = new Promise((resolve, reject) => {
  //         getInvoiceDetailsByID(values, (data) => {

  //           let result = data.Result_Output[0];
  //           console.log("getInvoiceDetailsByID", result)
  //           if (result.invoiceStatus === "Paid") {
  //             return navigate('/invoices');
  //           }
  //           else if (result.length > 0 && result) {
  //             setFinalise((result?.emailSent > 0) ? true : false);
  //             setValues({ ...values, ...result, });
  //             const apiItems = result.items || [];

  //             if (result.items?.length > 0) {
  //               setItemRowValues([
  //                 ...apiItems,
  //                 { ...EMPTY_ITEM_ROW }
  //               ]);
  //             } else {
  //               setItemRowValues([{ ...EMPTY_ITEM_ROW }]);
  //             }

  //             if (result.invoiceDocuments?.length > 0) {
  //               setDocuments(result.invoiceDocuments);
  //             }
  //             resolve();

  //             if (result.retentions?.length > 0) {
  //               setScheduleRetention(true);
  //               setRetentionItemValues(result.retentions);
  //             }
  //             setShowInvoicePaymentLink(result.showPaymentSection);

  //           }
  //         }, dispatch);
  //       });
  //     }
  //     // Wait for both promises to resolve
  //     await Promise.all([itemsPromise, detailsPromise]);
  //   } catch (error) {
  //     console.error("Error in FetchQuotationDetailsByID:", error);
  //     // Handle errors as needed
  //   }

  // }

  const EMPTY_ITEM_ROW = {
    itemID: "",
    itemName: "",
    itemPrice: "",
    itemDescription: "",
    categoryCodeName: "",
    itemQuantity: "",
    gst: "",
    discountType: "None",
    discountValue: "",
    discountAmount: 0,
    totalItemPrice: 0,
  };
  const handleChangeApprovedQuotation = (name) => (event, newValue) => {
    if (newValue) {
      const selectedItem = quotationDetails.find(quotation => quotation._id === newValue.id);
      console.log("selsctItem", selectedItem);
      if (selectedItem) {
        setValues({
          ...values,
          [name]: selectedItem.quotationNumber,
          quotationID: newValue.id,

          contactID: selectedItem.contactID,
          gstType: selectedItem.gstType,
          finalAmount: selectedItem.finalAmount,
          paymentInstruction: selectedItem.paymentInstruction,
          purchaseOrderNumber: selectedItem.purchaseOrderNumber,
          totalAmount: selectedItem.totalAmount,
          totalDiscountAmount: selectedItem.totalDiscountAmount,
        })
        setItemRowValues(selectedItem.items);
        setDocuments(selectedItem.quotationDocuments)
        // setShowItemAndDocumentSection(true);

      }
    } else {
      setValues({ ...values, [name]: '', quotationID: '' });
    }
  }
  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  function calculateDueUpto(paymentTerms, invoiceDate) {
    try {
      const currentDate = new Date(invoiceDate);

      switch (paymentTerms) {
        case 'Same Day':
          return currentDate;
        case '7 Days':
          return addDays(currentDate, 7);

        case '14 Days':
          return addDays(currentDate, 14);

        case '30 Days':
          return addDays(currentDate, 30);

        case '14 Days End of Month':
          return addDays(endOfMonth(currentDate), 14);

        case '30 Days End of Month':
          return addDays(endOfMonth(currentDate), 30);

        default:
          throw new Error('Invalid payment term');
      }

    } catch (error) {
      console.error("calculateDueUpto Error", error);
    }

  }

  const handleValidUptoDate = (paymentTerms) => {
    try {
      const dueDate = calculateDueUpto(paymentTerms, values.invoiceDate);
      setValues(prevValues => ({
        ...prevValues,
        dueDate: dueDate,
        dueUpto: paymentTerms,
      }));
    } catch (error) {
      console.error("handleValidUptoDate Error", error);
    }
  };
  const handleChangeCustomer = (name) => (event, newValue) => {
    if (newValue) {
      if (newValue.value === 'add-new') {

        navigate("/contacts/addContact?new=invoice")
      } else {
        const paymentTerms = contactDetails.find(customer => customer._id === newValue.value).paymentTerms || "30 Days End of Month";
        handleValidUptoDate(paymentTerms);
        // setValues({ ...values, [name]: newValue.label, contactID: newValue.value });
        setValues(prevValues => ({
          ...prevValues,
          [name]: newValue.label,
          contactID: newValue.value
        }));
      }
    } else {
      setValues({ ...values, [name]: '', contactID: '' });
    }
  }
  const handleValidUpto = (name) => (event) => {
    if (name === 'dueUpto') {
      handleValidUptoDate(event.target.value);
    }
  }
  //Handle Save or Update Quotation Function
  const handleChange = (name) => (event) => {
    let value = event.target.value;

    if (name === "gstType") {
      setValues(prev => ({ ...prev, gstType: value }));
      handleCalculation(value);

    }

    else if (name === "contactID" && value === "add_new") {
      navigate("/contacts/addContact?new=invoice");
    }
    else if (name === "invoiceType" && value === "Through Quotation" && quotationDetails.length <= 0) {
      swal({ icon: "warning", text: "Please proceed with Direct Invoice Type.", title: "There is no Approved Quotation Available!", closeOnClickOutside: false, closeOnEsc: false });
    }
    else if (name === "invoiceType" && value === "Direct") {
      if (values.quotationID) {
        ShowSwalWithButtons(
          `Are you sure, you want to change Invoice Type.`,
          `Changing Invoice Type to 'Direct' will clear all quotation-related fields. Are you sure you want to continue?`,
          "warning",
          darkMode,
          () => {
            setValues({
              ...values,
              [name]: event.target.value,
              quotationID: "",
              quotationNumber: "",
              contactID: "",
              gstType: "",
              finalAmount: "",
              paymentInstruction: "",
              purchaseOrderNumber: "",
              totalAmount: "",
              totalDiscountAmount: "",
            })
            setItemRowValues([]);
            setDocuments([]);
            // setShowItemAndDocumentSection(false);
          }
        )

      }
      else setValues({ ...values, [name]: value, quotationID: "" });

    }
    else if (event.target.validity && event.target.validity.valid) {
      setValues({ ...values, [name]: value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: value });
    }
  }
  const clearAllErrorMsg = () => {
    setContactNameErr(false);
    setInvoiceNoErr(false);
  }

  function identifyMissingItems(itemRowValues) {
    let missingItems = [];
    itemRowValues.forEach((row, index) => {
      if (!row.itemID || !row.itemPrice || !row.itemQuantity) {
        missingItems.push(index + 1);
      }
    });

    if (missingItems.length === 0) {
      return "All items are filled in.";
    }

    let missingItemsMessage = "Please fill in all of the following items before creating the invoice:\n";
    missingItems.forEach(itemIndex => {
      missingItemsMessage += `Row ${itemIndex}: `;
      if (!itemRowValues[itemIndex - 1].itemID) {
        missingItemsMessage += "Item Name, ";
      }
      if (!itemRowValues[itemIndex - 1].itemPrice) {
        missingItemsMessage += "Item Price, ";
      }
      if (!itemRowValues[itemIndex - 1].itemQuantity) {
        missingItemsMessage += "Item Quantity, ";
      }

      missingItemsMessage = missingItemsMessage.slice(0, -2); // Remove the last comma and space
      missingItemsMessage += "\n";
    });

    return missingItemsMessage;
  }

  const handleSaveInvoice = async (redirectToOutside = null) => {

    type && (values.type = type);
    clearAllErrorMsg();
    let mandateFlag = false;

    let invoiceDate = new Date(values.invoiceDate);
    invoiceDate.setUTCHours(0, 0, 0, 0);

    let dueDate = new Date(values.dueDate);
    dueDate.setUTCHours(23, 59, 59, 999);

    if (dueDate <= invoiceDate) {
      return showResMsg("Due date should be more than Invoice date", 2000, false);
    }
    if (values.contactID === '') {
      mandateFlag = validateField(values.contactID, setContactNameErr) || mandateFlag;
      return;
    }


    values.invoiceID = InvoiceID ? InvoiceID : values.invoiceID;

    if (InvoiceID) {
      values.scheduleRetention = scheduleRetention;
      if (scheduleRetention) {
        if (parseFloat(values.finalAmount) > parseFloat(usedRetentionAmount)) {
          Swal.fire({
            icon: 'warning', title: 'You have pending the Retention Amount.',
            text: 'You have chosen the Schedule Retention. To proceed, please complete all Retention Limit Amounts',
            customClass: {
              confirmButton: 'swal-button swal-button--confirm-green',
              popup: darkMode ? "darkPopup" : "whitePopup"
            },
            didOpen: () => {
              const popup = Swal.getPopup();
              popup.style.marginLeft = '200px';
            }
          });
          mandateFlag = true;
        } else {
          values.retentionList = retentionItemValues;
        }
      }
      mandateFlag = validateField(values.invoiceNumber, setInvoiceNoErr) || mandateFlag;
      const filterItemList = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== null && item.itemID !== undefined);


      if (filterItemList.length > 0) {
        const allRowsFilled = filterItemList.every(row => row.itemID && row.itemPrice && row.itemQuantity && row.categoryCodeName && row.discountValue !== "");
        if (allRowsFilled) {
          values.itemsList = filterItemList;
        } else {
          return showResMsg(identifyMissingItems(filterItemList), 2000, false);
        }
      } else {

        if (redirectToOutside === 'redirectToItemWhenSave') {
          navigate(`/items/addItems?new=invoice&id=${InvoiceID}`);
          console.log("redirectToOutside", redirectToOutside)
          return;
        } else {
          showResMsg("Please select at least 1 Item", 2000, false);
          return;
        }

      }


    }
    else if (typeQuotation) {

      values.throughQuotation = typeQuotation;
      // values.itemsList = itemRowValues;
      values.documentsList = quoDocuments;
      const filterItemList = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== null && item.itemID !== undefined);

      if (filterItemList.length > 0) {
        const allRowsFilled = filterItemList.every(row => row.itemID && row.itemPrice && row.itemQuantity && row.categoryCodeName && row.discountValue !== "");
        if (allRowsFilled) {
          values.itemsList = filterItemList;
        } else {
          return showResMsg(identifyMissingItems(filterItemList), 2000, false);
        }
      } else {

        showResMsg("Please select at least 1 Item", 2000, false);
        return;
      }
    } else {
      const filterItemList = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== null && item.itemID !== undefined);
      console.log("filterItemList", filterItemList)
      if (filterItemList.length > 0) {
        const allRowsFilled = filterItemList.every(row => row.itemID && row.itemPrice && row.itemQuantity && row.categoryCodeName && row.discountValue !== "");
        if (allRowsFilled) {
          values.itemsList = filterItemList;
        } else {
          return showResMsg(identifyMissingItems(filterItemList), 2000, false);
        }
      } else {
        if (redirectToOutside === 'redirectToItemWhenSave') {
          values.itemsList = [];
          console.log("redirectToOutside", redirectToOutside)
        } else {
          showResMsg("Please select at least 1 Item", 2000, false);
          return;
        }

      }
    }
    console.log("itemRowValues", itemRowValues)
    delete values.lists;
    if (mandateFlag) return
    values.currencyValue = currencyCode;
    console.log("valuessss-handleApiResponse", values)


    handleApiResponse({
      isUpdate: InvoiceID !== undefined,
      values,
      setOpen,
      showResMsg,
      navigate,
      handleSoftDismisal,
      setShowBillingModal,
      dispatch,
      redirectToOutside: redirectToOutside,
      InvoiceID,
      // redirectToOutside: (InvoiceID !== undefined),
    });


  }
  const handleSoftDismisal = () => {
    ShowSwalWithButtons(
      `The Reference number already exists`,
      'Do you wish to continue?',
      'warning',
      darkMode,
      () => {
        values.skip_PO_NO = true;
        handleSaveInvoice();
      }
    );
  }


  const handleAddNewItem = async () => {
    if (typeQuotation && !InvoiceID) {
      return; // Exit the function early without doing anything
    }

    console.log("redirectToOutside")
    await handleSaveInvoice('redirectToItemWhenSave');
  }
  //Handles Item Rows Functions
  const handleRemove = (index) => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to remove the Item?`, 'warning', darkMode,
      () => {
        if (itemRowValues.length > 1) {
          const list = [...itemRowValues];
          list.splice(index, 1);
          setItemRowValues(list);
        } else {

          setItemRowValues([{
            itemName: "", itemID: "", itemPrice: "", itemQuantity: "", itemDescription: "", categoryCodeName: "", gst: "",
            discountType: "None", discountValue: "", discountAmount: 0, totalItemPrice: 0,
          }])
        }
      }
    );

  };
  const handleEdit = (id, index) => {
    sessionStorage.setItem("ItemIdForItemEdit", id);
    ShowSwalWithButtons(
      "Are you sure?",
      "Would you like to Edit the Item?",
      "warning",
      darkMode,
      async () => {
        await handleSaveInvoice('redirectToEditItemWhenSave');

      }
    );

  };

  const handleCancel = (index) => {
    ShowSwalWithButtons(
      'Are you sure?',

      `Would you like to exit from this ${InvoiceID
        ? "Edit Invoice"
        : "Add New Invoice"
      }?`,
      'warning',
      darkMode,
      () => {
        const paramValue = new URLSearchParams(window.location.search).get('status');
        let routePath = '/invoices'; // default
        switch (paramValue) {
          case "debt":
            routePath = '/debts';
            break;
          default:
            routePath = '/invoices';
            break;
        }
        navigate(routePath); // ✅ redirect user
      }
    );

  };

  const addNewRowInList = (updatedRows) => {
    const emptyRowCount = updatedRows.filter(row => row.itemID === "" || row.itemID === undefined).length;
    if (emptyRowCount < 1) {
      setItemRowValues([
        ...updatedRows,
        {
          itemID: "", itemName: "", itemPrice: "", itemDescription: "", categoryCodeName: "", itemQuantity: "", gst: "",
          discountType: "None", discountValue: "", discountAmount: 0, totalItemPrice: 0,
        }
      ]);
    }
  };

  const calculateDiscountAmount = (newItemRowValues) => {
    console.log("calculateDiscountAmount called", newItemRowValues);
    const updatedRows = newItemRowValues.map((item, idx) => {
      const itemPrice = parseFloat(item.itemPrice);
      const itemQuantity = parseFloat(item.itemQuantity);
      const discountValue = parseFloat(item.discountValue);
      let discountAmount = 0;
      const totalAmount = itemPrice * itemQuantity;
      if (item.discountType === "Percentage") {
        discountAmount = totalAmount * discountValue / 100;
      } else {
        discountAmount = discountValue;
      }
      return { ...item, discountAmount: parseFloat(discountAmount.toFixed(2)) || 0 };
    });
    setItemRowValues(updatedRows);
    handleCalculation(values.gstType);
  };

  const handleCalculation = (gstType) => {
    let TotalAmount = 0;
    let TotalDiscountAmount = 0;
    let TotalGSTAmount = 0;
    let FinalAmount = 0;
    console.log("gstType in handleCalculation", itemRowValues, gstType)
    itemRowValues
      .filter(item => item.itemID) // 🔑 ignore empty row
      .forEach(item => {
        let itemPrice = item.itemPrice || 0;
        let itemQuantity = item.itemQuantity || 0;
        let discount = item.discountAmount || 0;
        let gst = item.gst || 0;
        let itemTotalPrice = itemPrice * itemQuantity;
        let baseAmount = 0;
        let taxAmount = 0;
        console.log("gstType in handleCalculation", gstType)
        if (["Inclusive", undefined].includes(gstType)) {
          const customerPayableAmount = itemTotalPrice;
          const Amount = calculatePrice(customerPayableAmount, gst, discount);
          baseAmount = Amount.itemActualPrice;
          taxAmount = Amount.taxAmount;
        } else {
          baseAmount = itemTotalPrice;
          taxAmount = gst * (itemTotalPrice - discount) / 100;
        }
        TotalAmount += baseAmount;
        TotalDiscountAmount += discount;
        TotalGSTAmount += taxAmount;
      });

    if (gstType === "Inclusive" || gstType === undefined) {
      FinalAmount = parseFloat(TotalAmount + TotalGSTAmount).toFixed(2);
    } else {
      FinalAmount = parseFloat((TotalAmount - TotalDiscountAmount) + TotalGSTAmount).toFixed(2);
    }

    setValues(prevValues => ({
      ...prevValues,
      gstType: gstType,
      totalAmount: parseFloat(TotalAmount).toFixed(2),
      totalDiscountAmount: parseFloat(TotalDiscountAmount).toFixed(2),
      totalGSTAmount: parseFloat(TotalGSTAmount).toFixed(2),
      finalAmount: parseFloat(FinalAmount).toFixed(2)
    }));
  }


  const handleItemRowChange = async (name, value, index) => {
    console.log("TTT", name, value, index)
    const updatedRows = [...itemRowValues];
    // if (name === 'itemPrice' || name === 'itemQuantity') {
    if (value === '.') {
      value = '0.';
    }

    const regex = /^\d{1,7}(?:\.\d{0,2})?$/;

    if (regex.test(value) || value === "") {

      if (name === 'itemPrice' || name === 'itemQuantity') {
        if (parseFloat(value) === 0 || value === "") {
          showResMsg(`${await convertToTitleCase(name)} cannot be zero`, 1000, false)
        }
        updatedRows[index] = { ...updatedRows[index], [name]: value };
        updatedRows[index].totalItemPrice = parseFloat((updatedRows[index].itemPrice) * (updatedRows[index].itemQuantity)).toFixed(2);
        setItemRowValues(updatedRows);
      }
      else if (name === 'discountValue') {
        console.log("discountValue called")
        if (itemRowValues[index].discountType === "Percentage" || itemRowValues[index].discountType === "Fixed") {
          if (value === "" || (parseFloat(value) < 100 && itemRowValues[index].discountType === "Percentage")) {
            // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
            updatedRows[index] = {
              ...updatedRows[index],
              discountValue: value === "" ? "" : value,
            };
            setItemRowValues(updatedRows);
          }

          if (value === "" || (parseFloat(value) < (parseFloat(itemRowValues[index].itemPrice) * parseFloat(itemRowValues[index].itemQuantity)) && itemRowValues[index].discountType === "Fixed")) {
            // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
            updatedRows[index] = {
              ...updatedRows[index],
              discountValue: value === "" ? "" : value,
            };
            setItemRowValues(updatedRows);
          }
        }
      }


    } else if (name === 'discountValue') {

      if (itemRowValues[index].discountType === "Percentage" || itemRowValues[index].discountType === "Fixed") {
        if (value === "" || (parseFloat(value) < 100 && itemRowValues[index].discountType === "Percentage")) {
          // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
          updatedRows[index] = {
            ...updatedRows[index],
            discountValue: value === "" ? "" : value,
          };
          setItemRowValues(updatedRows);
        }

        if (value === "" || (parseFloat(value) < parseFloat(itemRowValues[index].itemPrice) && itemRowValues[index].discountType === "Fixed")) {
          // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
          updatedRows[index] = {
            ...updatedRows[index],
            discountValue: value === "" ? "" : value,
          };
          setItemRowValues(updatedRows);
        }
      }
    } else if (name === "discountType" && value === "None") {
      updatedRows[index] = { ...updatedRows[index], [name]: value, discountValue: 0, discountAmount: 0 };
      setItemRowValues(updatedRows);
    } else if (name === "discountType" && value === "Fixed") {
      updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: parseFloat(itemRowValues[index].discountValue) };
      setItemRowValues(updatedRows);
    } else if (name === "discountValue" && itemRowValues[index].discountType === "Fixed") {
      updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: parseFloat(value) };
      setItemRowValues(updatedRows);
    } else {
      updatedRows[index] = { ...updatedRows[index], [name]: value };
      setItemRowValues(updatedRows);
    }
  };

  const handleItemDescription = async (name, value, index) => {
    const updatedRows = [...itemRowValues];
    updatedRows[index] = { ...updatedRows[index], [name]: value };
    setItemRowValues(updatedRows);
  };

  const handleItemRow = async (name, newValue, index) => {
    console.log("dataaas", index, name, newValue)
    if (!newValue) {
      showResMsg("Please select an item", 1000, false);
    }
    if (newValue.value === 'add-new') {
      handleAddNewItem();
    } else {
      const selectedItem = masterItemDetails.find(item => item._id === newValue.value);
      if (selectedItem) {
        const updatedRows = [...itemRowValues];
        updatedRows[index] = {
          ...updatedRows[index],
          itemID: newValue.value,
          itemName: selectedItem.itemName,
          itemDescription: selectedItem.itemDescription ? selectedItem.itemDescription : selectedItem.itemName,
          categoryCodeName: selectedItem.categoryCodeName,
          itemPrice: parseFloat(selectedItem.itemPrice),
          itemQuantity: parseFloat(selectedItem.itemQuantity),
          totalItemPrice: (parseFloat(selectedItem.itemPrice).toFixed(2)) * (parseFloat(selectedItem.itemQuantity).toFixed(2)),
          gst: parseFloat(selectedItem.gst),
          discountType: selectedItem.discountType,
          discountValue: parseFloat(selectedItem.discountValue).toFixed(2),
          discountAmount: selectedItem.discountType === "Fixed" ? selectedItem.discountValue : 0,
        };
        setItemRowValues(updatedRows);
        handleCalculation(values.gstType);
      }
    }
  };

  useEffect(() => {
    const itemFromUrl = new URLSearchParams(window.location.search).get('item');
    if (itemFromUrl) {
      const selectedItem = masterItemDetails.find(item => item._id === itemFromUrl);
      console.log("selectedItem", selectedItem)
      if (selectedItem) {
        const newItemValue = { value: itemFromUrl };

        // Find the first empty row (if any)
        const emptyRowIndex = itemRowValues.findIndex(row => !row.value && row.value !== undefined && row.value !== null);
        console.log("Emptyhj", emptyRowIndex)
        if (emptyRowIndex !== -1) {
          // Update the first empty row found
          console.log("Emptyhj", emptyRowIndex)

          handleItemRow('', newItemValue, emptyRowIndex);
        } else {
          // If no empty row is found, update the last row or add new row logic
          const lastIndex = itemRowValues.length - 1;
          console.log("itemslist", lastIndex)
          handleItemRow('', newItemValue, lastIndex);

          console.warn('No empty row found, updating the last row instead');
        }
      }

    }
    if (JSON.stringify(retentionItemValues) !== JSON.stringify(retentionItemValuesRef.current)) {
      retentionItemValuesRef.current = retentionItemValues;
      const sum = retentionItemValues.reduce((acc, curr) => parseFloat(acc) + parseFloat((curr.retentionPaymentAmount || 0)), 0);
      setUsedRetentionAmount(sum)
    }
  }, [retentionItemValues, masterItemDetails]);





  const filteredOptions = itemsDetails.map(item => ({
    label: item.itemName,
    value: item._id,
  }));

  const coloredShadowChange = document.querySelectorAll(".dayHour");
  if (coloredShadowChange) {
    for (let i = 0; i < coloredShadowChange.length; i++) {
      coloredShadowChange[i].style.color = darkMode ? "white" : "black";
    }

  }


  let columns = [
    {
      name: <p style={{ fontSize: "12px" }}>Item Name</p>,
      selector: (row, i) => (
        <Autocomplete
          disableClearable
          key={`${i}-${row.itemID}`}
          id={`item-${i}`}
          sx={{
            '& .MuiInputBase-root': {
              width: "170px"
            }
          }}
          options={[{ label: "Add New Item", value: "add-new" }, ...filteredOptions]}
          onChange={(event, newValue) => handleItemRow("itemID", newValue, i)}
          value={row.itemName}
          isOptionEqualToValue={(option, value) => option.label === value}
          renderInput={(params) =>
            <TextField {...params}
              autoFocus
              variant="standard"
              placeholder="Search for an Item"
              size="medium"
              // sx={{ color: darkMode ? "white" : "black", }}
              sx={{
                "& .MuiInput-root": {
                  height: "35.11px",
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,

                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },

              }}
              inputProps={{
                ...params.inputProps,
                maxLength: 200,   // ⭐ Max length applied
              }}
            />
          }

          renderOption={(props, option) => {
            // const customStyle = option.value === 'add-new' ? 'dropDownDefaultHighlight' : darkMode ? 'autoCompleteDarkList' : 'autoCompleteList';
            const customStyle = option.value === 'add-new'
              ? (darkMode ? tableBorder : tableBorder)
              : (darkMode ? 'autoCompleteDarkList' : 'autoCompleteList');

            return (
              <li
                {...props}
                key={option.value}
                style={{ fontSize: '12px', color: darkMode ? tableBorder : tableBorder, padding: "4.8px 16px", fontWeight: "bold", fontFamily: "Roboto, Helvetica, Arial, sans-serif", cursor: 'pointer' }}
                className={customStyle}

              >
                {option.label}
              </li>)
          }}

          filterOptions={(options, state) => {
            const filtered = options.filter(option => option.label.toLowerCase().includes(state.inputValue.toLowerCase()));
            if (!filtered.some(option => option.value === 'add-new')) {
              filtered.unshift({ label: "Add New Item", value: "add-new" });
            }
            return filtered;
          }}
        />
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '170px',
      marginTop: "4px"

    },
    {
      name: <p style={{ fontSize: "12px" }}>Description</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              value={row.itemDescription}
              onChange={(event) => handleItemDescription("itemDescription", event.target.value, i)}
              autoComplete="off"
              className="removeExtraPadding"
              id="standard-textarea"
              placeholder="Description"
              multiline
              variant="standard"
              sx={{
                '& .MuiInputBase-root': {
                  width: "320px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              InputProps={{
                style: {
                  fontSize: '12px',
                  whiteSpace: 'pre-wrap',
                  overflowWrap: 'break-word',
                  width: "100%",
                  minWidth: '300px',
                  color: darkMode ? "white" : "black",
                  boxSizing: 'border-box',
                  display: 'block',
                },
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '260px',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Qty</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              autoComplete="off"
              type="text"
              className="removeExtraPadding "
              fullWidth
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "")}
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              variant="standard"
              value={row.itemQuantity}
              onChange={(event) => handleItemRowChange("itemQuantity", event.target.value, i)}
              inputProps={{
                maxLength: 5,
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Item Price</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={formatNumberWithCommas(row.itemPrice)}
              variant="standard"
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "")}
              onChange={(event) => handleItemRowChange("itemPrice", event.target.value, i)}
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                // pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },

    {
      name: <p style={{ fontSize: "12px", }}>Amount</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={formatCurrencyAUD(row.totalItemPrice)}
              variant="standard"
              onChange={(event) => handleItemRowChange("totalItemPrice", event.target.value, i)}
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              disabled
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },


    {
      name: <p style={{ fontSize: "12px" }}>Account</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              disabled
              type="text"
              value={row.categoryCodeName}
              variant="standard"
              onChange={(event) => handleItemRowChange("categoryCodeName", event.target.value, i)}
              fullWidth
              className="dayHour"
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '200px',
    },

    {
      name: <p style={{ fontSize: "12px" }}>GST (%)</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}


              value={row.gst}
              onChange={(event) => handleItemRowChange("gst", event.target.value, i)}
              disabled
              style={{ cursor: 'default', pointerEvents: 'none' }}

            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Discount Type</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormControl fullWidth variant="standard" sx={{ m: 1, mt: 0, ml: -1.5 }}>
              <Select
                style={{ height: "35.11px", marginTop: "1.5px" }}
                labelId="day-hours-select-label"
                id="day-hours-select"
                className="dayHour"
                value={row.discountType}
                onChange={(event) => handleItemRowChange("discountType", event.target.value, i)}
                fullWidth
                sx={{
                  width: "100px"
                  ,
                  color: darkMode ? "white" : "black",
                  '& .MuiInputBase-root ': {


                  },
                  '&:before': {
                    borderBottomColor: darkMode ? "white" : tableBorder,
                  },
                  '&:hover:not(.Mui-disabled):before': {
                    borderBottomColor: darkMode ? "white" : tableBorder
                  },
                  '&:after': {
                    borderBottomColor: darkMode ? tableBorder : tableBorder,
                  },
                  '& .MuiSelect-select': {
                    color: darkMode ? "white" : "black",
                  },
                }}
                variant="standard"
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Percentage">Percentage</MenuItem>
                <MenuItem value="Fixed">Fixed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '140px',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Discount Value</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth
              sx={{
                color: darkMode ? "white" : "black",
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              disabled={row.discountType === "None"}
              value={row.discountType === "None" ? 0 : row.discountValue ?? ""}
              // value={row.discountType === "None" ? 0 : row.discountValue}
              onChange={(event) => handleItemRowChange("discountValue", event.target.value, i)}
              inputProps={{
                maxLength: 30,
                pattern: "^[a-zA-Z0-9 ]+$",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },

    },

    {
      // name: "Action",
      name: <p></p>,
      selector: (row) => row._id,
      cell: (row, i) => (
        <>
          <Grid container style={{ display: "flex", justifyContent: "center" }} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              {row.itemID ?

                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => {
                    handleRemove(i);
                  }}
                  title="Delete"
                />
                :
                <TimelineItem
                  color="gray"
                  icon="delete"
                  title="Delete"
                />


              }

            </Grid>
            <Grid item>
              {row.itemID ?
                <TimelineItem
                  color="success"
                  icon="edit"
                  onClick={() => {
                    handleEdit(row.itemID, i);
                  }}
                  title="Edit"
                />
                :
                <TimelineItem
                  color="gray"
                  icon="edit"
                  title="Edit"
                />
              }

            </Grid>
          </Grid>
        </>
      ),



    },
  ];
  let quotationReadOnlyColumns = [

    {
      name: <p style={{ fontSize: "12px" }}>Item Name</p>,
      selector: (row, i) => (
        <Autocomplete
          disableClearable
          key={`${i}-${row.itemID}`}
          id={`item-${i}`}
          sx={{
            '& .MuiInputBase-root': {
              width: "170px"
            }
          }}
          options={[{ label: "Add New Item", value: "add-new" }, ...filteredOptions]}
          onChange={(event, newValue) => handleItemRow("itemID", newValue, i)}
          value={row.itemName}
          isOptionEqualToValue={(option, value) => option.label === value}
          renderInput={(params) =>
            <TextField {...params}
              autoFocus
              disabled
              variant="standard"
              placeholder="Search for an Item"
              size="medium"
              // sx={{ color: darkMode ? "white" : "black", }}
              sx={{
                "& .MuiInput-root": {
                  height: "35.11px",
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,

                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },

              }}
            />
          }
          renderOption={(props, option) => {
            // const customStyle = option.value === 'add-new' ? 'dropDownDefaultHighlight' : darkMode ? 'autoCompleteDarkList' : 'autoCompleteList';
            const customStyle = option.value === 'add-new'
              ? (darkMode ? tableBorder : tableBorder)
              : (darkMode ? 'autoCompleteDarkList' : 'autoCompleteList');
            return (
              <li
                {...props}
                key={option.value}
                style={{ fontSize: '12px', color: darkMode ? tableBorder : tableBorder, padding: "4.8px 16px", fontWeight: "bold", fontFamily: "Roboto, Helvetica, Arial, sans-serif", cursor: 'pointer' }}
                disabled={typeQuotation && !InvoiceID}
                className={customStyle}
              >
                {option.label}
              </li>)
          }}

          filterOptions={(options, state) => {
            const filtered = options.filter(option => option.label.toLowerCase().includes(state.inputValue.toLowerCase()));

            if (!filtered.some(option => option.value === 'add-new')) {
              filtered.unshift({ label: "Add New Item", value: "add-new" });
            }
            return filtered;
          }}
        />
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '170px',
      marginTop: "4px"

    },
    {
      name: <p style={{ fontSize: "12px" }}>Description</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              value={row.itemDescription}
              onChange={(event) => handleItemDescription("itemDescription", event.target.value, i)}
              autoComplete="off"
              className="removeExtraPadding"
              id="standard-textarea"
              placeholder="Description"
              multiline
              disabled
              variant="standard"
              sx={{
                '& .MuiInputBase-root': {
                  width: "320px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              InputProps={{
                style: {
                  fontSize: '12px',
                  whiteSpace: 'pre-wrap',
                  overflowWrap: 'break-word',
                  width: "100%",
                  minWidth: '300px',
                  color: darkMode ? "white" : "black",
                  boxSizing: 'border-box',
                  display: 'block',
                },
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '360px',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Qty</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              autoComplete="off"
              type="text"
              className="removeExtraPadding "
              fullWidth
              disabled
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "")}
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              variant="standard"
              value={row.itemQuantity}
              onChange={(event) => handleItemRowChange("itemQuantity", event.target.value, i)}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Item Price</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={row.itemPrice}
              variant="standard"
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "")}
              onChange={(event) => handleItemRowChange("itemPrice", event.target.value, i)}
              fullWidth
              disabled
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 10,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Amount</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={row.totalItemPrice}
              variant="standard"
              disabled
              onChange={(event) => handleItemRowChange("totalItemPrice", event.target.value, i)}
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },


    {
      name: <p style={{ fontSize: "12px" }}>Account</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              disabled
              type="text"
              value={row.categoryCodeName}
              variant="standard"
              onChange={(event) => handleItemRowChange("categoryCodeName", event.target.value, i)}
              fullWidth
              className="dayHour"
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '200px',
    },

    {
      name: <p style={{ fontSize: "12px" }}>GST (%)</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth
              disabled
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}


              value={row.gst}
              onChange={(event) => handleItemRowChange("gst", event.target.value, i)}
              style={{ cursor: 'default', pointerEvents: 'none' }}

            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },

  ];
  const [fileError, setFileError] = useState('');
  //Quotation Document Functions
  const saveFile = async (event) => {
    const file = event.target.files[0];
    console.log("file", file)
    const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
    console.log("fileName", fileNameWithoutExtension);
    setValues((prev) => ({
      ...prev,
      documentName: fileNameWithoutExtension,
    }));

    if (file && file.type) {

      if (file.size > 1 * 1024 * 1024) {
        setFileError('File size should be less than 1 MB');
        return;
      } else {
        document.getElementById("invoiceDocuments").value = file.name;
        setFileError('');
        console.log("values.documentName", values.documentName)
        if (file.name) {
          try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("invoiceID", values.invoiceID);
            formData.append("documentName", fileNameWithoutExtension);
            formData.append("fileType", await getFileType(file.type))
            values.selectedID && formData.append("documentID", values.selectedID);
            setLoading(true);

            await axios.post(appConstants.baseURL + "invoice/uploadInvoiceDocument", formData, {
              headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` }
            }).then(res => {
              let response = res.data;
              setLoading(false);
              showResMsg(response.Result_Message, 2000, response.Result_Status);
              if (response.Result_Status) {
                // setShowItemAndDocumentSection(true);
                setValues({ ...values, documentName: "", selectedID: "" });
                setDocuments(response.Result_Output);
                document.getElementById("invoiceDocuments").value = "";
              }
            })

          } catch (error) {
            console.log("error addDocument", error);
          }
        }
        else {
          setFileError("Please enter Document Name");
        }
      }
    } else {
      console.log('No file selected or file object is false/undefined');
      showResMsg('Please select a valid file!', 2000, false);
      setFileError('');
    }
  };

  const handleEditDocument = (selectedDocRow) => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to edit "${selectedDocRow.documentName}" file?`, 'warning', darkMode,
      () => {
        setValues({ ...values, documentName: selectedDocRow.documentName, selectedID: selectedDocRow._id });
      }
    );


  }


  const handleDeleteDocument = async (selectedDocRow) => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to delete "${selectedDocRow.documentName}" file?`, 'warning', darkMode,
      () => {
        axios.post(appConstants.baseURL + "invoice/deleteInvoiceDocument", { documentID: selectedDocRow._id }, {
          headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` }
        }).then(
          res => {
            if (res.data.Result_Status) {
              showResMsg(genericMessage.documentDeleted, 1000, res.data.Result_Status);

              const updatedQuoDocument = quoDocuments.filter(item => {
                return item.documentName !== selectedDocRow.documentName;
              });
              setDocuments(updatedQuoDocument);
            } else {
              showResMsg(res.data.Result_Message, 2000, false);
            }
          }).catch(error => {
            console.log("deleteQuotationDocument error", error.message);
          })
      }
    );

  }

  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action(s)",
      selector: (row) => row,
      center: 'true',
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>


            <Grid item>
              {row.fileType === "docx" || row.fileType === "doc" || row.fileType === "excel" ?
                <a className="testing" href={appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + row.documentFileName} download target="_blank" rel="noopener noreferrer">
                  <TimelineItem
                    color="info"
                    icon="visibility"
                    onClick={() => { renderFilePreview(row) }}
                    title="View"
                  // disabled={SCREEN_RIGHT === "View Only"}
                  /></a> : <TimelineItem
                  color="info"
                  icon="visibility"
                  onClick={() => { handleViewDocument(row) }}
                  title="View"
                // disabled={SCREEN_RIGHT === "View Only"}
                />}

            </Grid>
            {InvoiceID && <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDocument(row)}
                title="Delete"
                disabled={SCREEN_RIGHT === "View Only"}
              />
            </Grid>}
          </Grid>
        </>
      ),
    },
  ];

  const handleDateChange = async (date) => {
    values.invoiceDate = await formatDateWithCurrentTimeForPickDate(date);
    setValues({ ...values, invoiceDate: values.invoiceDate });

  };

  const handleDueDateChange = async (date) => {
    values.dueDate = await formatDateWithCurrentTimeForPickDate(date);
    setValues({ ...values, dueDate: values.dueDate });
  };


  const addNewRetentionRow = () => {
    const allRowsFilled = retentionItemValues.every(row => row.retentionPaymentAmount && row.retentionDueDate);
    if (allRowsFilled) {
      if (parseFloat(usedRetentionAmount) < parseFloat(values.finalAmount)) {
        const InvoiceDueDate = new Date(values.dueDate).toLocaleDateString();
        retentionItemValues.some((element, index) => {
          const retentionDueDate = new Date(element.retentionDueDate).toLocaleDateString();
          if (retentionDueDate > InvoiceDueDate) {

            setLoading(true);
            setTimeout(async () => {
              showResMsg(`Retention Due Date on ${values.invoiceNumber}/R${index + 1} can't be more than Invoice Due Date`, 2000, false);
              setLoading(false);
            }, 2000);

            return true;
          }
          return false;
        });

        setRetentionItemValues([...retentionItemValues, {
          retentionPaymentAmount: "",
          retentionNumber: `${values.invoiceNumber}/R${retentionItemValues.length + 1}`,
          retentionDueDate: new Date(new Date() - (new Date().getTimezoneOffset() * 60000)),
        }]);
      } else {
        setLoading(true);
        setTimeout(async () => {
          showResMsg(`Unable to add row for Retention as Retention limit has been reached.`, 2000, false);
          setLoading(false);
        }, 2000);
      }
    } else {
      showResMsg("Please fill in all Fields values before adding a new row for retention.", 2000, false);
    }
  };

  const handleRemoveRetention = (index) => {
    if (retentionItemValues.length >= 1) {
      ShowSwalWithButtons(
        'Are you sure?', `Would you like to remove this Retention?`, 'warning', darkMode,
        () => {
          const list = [...retentionItemValues];
          list.splice(index, 1);
          list.forEach(element => {
            element.retentionNumber = `${values.invoiceNumber}/R${list.indexOf(element) + 1}`
          });
          setRetentionItemValues(list);
          if (list.length === 0) {
            setScheduleRetention(false);
          }
        }
      );
    }

  };
  const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date);
  };
  let columnRetention = [
    {
      name: "Retention No.",
      selector: (row, i) => (
        <TextField
          type="text"
          value={row.retentionNumber}
          variant="outlined"
          fullWidth
          disabled
        />
      ),
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
        display: "block"
      },
    },
    {
      name: `Payment Amount (${currencyCode})`,
      selector: (row, i) => (
        <TextField
          type="text"
          value={row.retentionPaymentAmount}

          variant="outlined"
          onChange={(event) => handleRetentionRowChange("retentionPaymentAmount", event.target.value, i)}
          autoFocus
          fullWidth
          disabled={row.retentionStatus === "Paid"}
          autoComplete="off"
          inputProps={{
            maxLength: 12,
            // pattern: "[]",
          }}
        />
      ),
      center: 'true',
      style: {
        paddingLeft: "20px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },

    {
      name: "Retention Due Date",
      selector: (row, i) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MobileDatePicker
            disabled={row.retentionStatus === "Paid"}
            value={isValidDate(new Date(row.retentionDueDate)) ? dayjs(new Date(row.retentionDueDate)) : dayjs(new Date())}
            onChange={(date) => handleRetentionRowChange("retentionDueDate", date, i)}
            renderInput={(params) => <TextField {...params} fullWidth />}
            format="MMM DD, YYYY"
            autoFocus={true}
            minDate={dayjs(new Date(values.invoiceDate))}
            maxDate={dayjs(new Date(values.dueDate))}
            disableCloseOnSelect={true}
            showToolbar={false}
          />
        </LocalizationProvider>
      ),
      center: 'true',
      style: {
        paddingLeft: "20px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },

    {
      name: "Action(s)",
      selector: (row) => row._id,
      center: 'true',
      cell: (row, i) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              {row.retentionStatus !== "Paid" ? <TimelineItem
                color="error"
                icon="delete"
                onClick={() => {
                  handleRemoveRetention(i);
                }}
                title="Delete Retention"
              /> :
                <TimelineItem
                  color="grey"
                  icon="delete"
                />
              }
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  const handleRetentionRowChange = async (name, value, index) => {

    const updatedRows = [...retentionItemValues];
    if (name === 'retentionPaymentAmount') {


      if (value === '.') {
        value = '0.';
      }
      const regex = /^\d{1,7}(?:\.\d{0,2})?$/;
      if (regex.test(value) || value === "") {

        if (parseFloat(value) === 0 || value === "") {
          showResMsg("Retention " + await convertToTitleCase(name) + " can't be zero", 2000, false);
        }
        updatedRows[index] = { ...updatedRows[index], [name]: value };
        const sum = updatedRows.reduce((acc, curr) => parseFloat(acc) + parseFloat((curr.retentionPaymentAmount || 0)), 0);

        if (parseFloat(sum) > parseFloat(values.finalAmount)) {
          setLoading(true);
          setTimeout(async () => {
            showResMsg(`Sum of Retention ${await convertToTitleCase(name)} can't be more than Retention Limit Amount`, 2000, false);
            setLoading(false);
          }, 2000);
          return
        } else {
          setRetentionItemValues(updatedRows);
        }
      }
    }
    else if (name === 'retentionDueDate') {
      updatedRows[index] = { ...updatedRows[index], [name]: new Date(value) };
      setRetentionItemValues(updatedRows);
    }
  };

  const handleSaveAndSendToEmail = async () => {
    if (itemRowValues.every(row => !row.itemID)) {

      showResMsg(genericMessage.noItemBeforeEmail, 2000, false);
    } else {
      ShowSwalWithButtons(
        'Are you sure?', `Would you like to send the Invoice ${values.invoiceNumber} via email to the Customer Email Address?`, 'question', darkMode,
        () => {
          values.sendEmailFlag = true;
          handleSaveInvoice();
        }
      );
    }

  }

  const handleRedirectToPaymentScreen = () => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to redirect the Invoice ${values.invoiceNumber} payment details?`, 'warning', darkMode,
      () => {
        navigate("/invoices/payment/" + InvoiceID)
      }
    );
  }

  const handleRetentionClick = () => {
    console.log("featureAccess", featureAccess)
    if (featureAccess) {
      setScheduleRetention(true);
      setRetentionItemValues([
        ...retentionItemValues,
        {
          retentionNumber: `${values.invoiceNumber}/R1`,
          retentionPaymentAmount: "",
          retentionDueDate: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
        }
      ]);
    } else {
      showResMsg(`${genericMessage.notAllowed}`, 2000, false);
    }
  };

  const handleViewDocument = (selectedDocRow) => {
    setSelectedFileType(selectedDocRow.fileType);
    if (selectedDocRow.fileType === "pdf" || selectedDocRow.fileType === "image") {
      const path = appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName;
      setSetDocumentFileURL(path);
      path && setViewDocumentInModal(true);
    } else {
      showResMsg("Document type not supported.", 2000, false)
    }

  };
  const renderFilePreview = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
  }
  const handleCloseViewModal = () => {
    setSetDocumentFileURL('');
    setSelectedFileType('');
    setViewDocumentInModal(false);
  }


  //Modal Email Template used fxn start
  const handleEmailQuotation = async () => {
    if (AllKeysHaveValue(templateValues)) {
      setOpen(true);
    } else {
      await getEmailAndTemplateForQuotation({ screenType: templateValues.screenType, contactID: values.contactID, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "") }, (data) => {
        if (data.Result_Status) {
          setTemplateValues(data.Result_Output);
          setOpen(true);
        } else {
          showResMsg("Please try again! Something went wrong");
          setOpen(false);
        }
      }, dispatch);
    }
  }

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  };

  const handleSend = (templateData) => {
    let payload = {
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
    };
    values.sendEmailFlag = true;
    values.templateValues = payload;
    handleSaveInvoice();
  }
  //Modal Email Template used fxn ends
  useEffect(() => {
    const contactFromUrl = new URLSearchParams(window.location.search).get('contact');
    if (contactFromUrl) {
      if (contactFromUrl === 'add-new') {
        handleChangeCustomer('name')('', { label: 'Add New Customer', value: 'add-new' });
      } else {
        const selectedContact = contactDetails.find(contact => contact._id === contactFromUrl);
        if (selectedContact) {
          handleChangeCustomer('name')('', { label: selectedContact.companyName, value: contactFromUrl });
        }
      }
    }
  }, [contactDetails]);



  useEffect(() => {
    const labelTextSpans = document.querySelectorAll(
      "label.MuiFormControlLabel-root span.MuiTypography-root"
    );

    labelTextSpans.forEach((sp) => {
      sp.style.color = darkMode ? "white" : "#1ed6ca";
    });
  }, [darkMode, tableBorder]);




  useEffect(() => {
    if (
      !quotationLoaded ||           // ✅ STATE, not ref
      !masterItemDetails.length
    ) return;
    const itemId = new URLSearchParams(window.location.search).get('item');

    console.log("itemId from URL:", itemId);
    if (!itemId) return;
    // ⛔ prevent duplicate insertion


    const selectedItem = masterItemDetails.find(
      item => item._id === itemId
    );

    if (!selectedItem) return;

    const urlItemRow = {
      itemID: selectedItem._id,
      itemName: selectedItem.itemName,
      itemDescription: selectedItem.itemDescription || selectedItem.itemName,
      categoryCodeName: selectedItem.categoryCodeName,
      itemPrice: Number(selectedItem.itemPrice),
      itemQuantity: Number(selectedItem.itemQuantity),
      gst: selectedItem.gst,
      discountType: selectedItem.discountType,
      discountValue: selectedItem.discountValue,
      discountAmount: 0,
      totalItemPrice: Number(selectedItem.itemPrice),
    };

    setItemRowValues(prev => {
      // remove EMPTY rows first
      const rowsWithoutEmpty = prev.filter(row => row.itemID);

      // avoid adding same URL item again
      const alreadyExists = rowsWithoutEmpty.some(
        row => row.itemID === itemId
      );

      if (alreadyExists) return prev;



      return [
        ...rowsWithoutEmpty, // API items
        urlItemRow,          // URL item
        { ...EMPTY_ITEM_ROW }
      ];

    });



  }, [quotationLoaded, masterItemDetails]);
  useEffect(() => {
    if (!itemRowValues.length) return;

    handleCalculation(values.gstType);
  }, [itemRowValues, values.gstType]);

  const customerOptions = [
    ...(showAddNewCustomer ? [{ label: 'Add New Customer', value: 'add-new' }] : []),
    ...contactDetails.map(contact => ({
      label: contact.companyName,
      value: contact._id
    }))
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName={screenName} />
          <Grid container px={2} mt={2} spacing={2}>

            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={4}>
              <Autocomplete
                id="customerName-select"
                options={customerOptions}
                // options={[
                //   { label: 'Add New Customer', value: 'add-new' },
                //   ...contactDetails.map(contact => ({ label: contact.companyName, value: contact._id }))]}
                renderOption={(props, option) => (
                  <li
                    {...props} key={option.value}
                    className={
                      darkMode ? `${option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteDarkList'}` : `${option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteList'}`
                    }
                  >
                    {option.label}
                  </li>
                )}
                filterOptions={(options, state) => {
                  const filtered = options.filter(option =>
                    option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                  );

                  if (
                    showAddNewCustomer &&
                    !filtered.some(option => option.value === 'add-new')
                  ) {
                    filtered.unshift({ label: 'Add New Customer', value: 'add-new' });
                  }

                  return filtered;
                }}
                // filterOptions={(options, state) => {
                //   const filtered = options.filter(option =>
                //     option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                //   );
                //   if (!filtered.some(option => option.value === 'add-new')) {
                //     filtered.unshift({ label: 'Add New', value: 'add-new' }); // Ensure 'Add New' is always in the filtered list
                //   }
                //   return filtered;
                // }}

                onChange={handleChangeCustomer("name")}
                isOptionEqualToValue={(option, value) => {
                  if (value === "") {
                    return true;
                  }
                  return option.value === value;
                }}
                value={(values.contactID && contactDetails.find(contact => contact._id === values.contactID)?.companyName) || (new URLSearchParams(window.location.search).get('contact') === 'add-new' ? 'Add New Customer' : "")}
                renderInput={(params) => (
                  <TextField {...params} className="ress" label="Customer" autoFocus={true} placeholder="Enter here"
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 25,   // <-- ⭐ Max 25 characters
                    }} />
                )}
                disabled={values.invoiceType === "Through Quotation" || finalise}
              />

              {contactNameErr ? <p style={errMsg}>Please Select Customer</p> : ""}
            </Grid>

            <Grid item lg={3} xs={6} >
              <PickDate
                selected={new Date(values.invoiceDate)}
                onChange={handleDateChange}
                label="Invoice Date"
                variant="outlined"
                disabled
                InputLabelProps={{ shrink: true }}
                minDate={new Date()}
              />

            </Grid>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Due Upto</InputLabel>
                <Select
                  labelId="dueUpto-label"
                  label="Due Upto"
                  style={{ height: "35px" }}
                  onChange={handleValidUpto("dueUpto")}
                  value={values.dueUpto}
                  displayEmpty
                >
                  <MenuItem disabled value="">Select Due Upto</MenuItem>
                  {paymentTermsOptions.map((option, index) => (
                    <MenuItem key={index} value={option}>{option}</MenuItem>
                  ))}
                </Select>

              </FormControl>
            </Grid>
            <Grid item lg={3} xs={12}>
              <PickDate
                selected={new Date(values.dueDate)}
                onChange={handleDueDateChange}
                label="Due Date"
                minDate={new Date(values.invoiceDate)}
              />
            </Grid>

            {/* Quotation Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Number"
                variant="outlined"
                disabled
                fullWidth
                inputProps={{
                  maxLength: 12,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                value={values.invoiceNumber}
              />
              {invoiceNoErr ? <p style={errMsg}>Quotation Number can't be blank.</p> : ""}
            </Grid>
            {/* Invoice Type */}
            <Grid item lg={1.5} xs={3}>
              <FormControl fullWidth>
                <InputLabel id="daysHours-select-label">Invoice Type</InputLabel>
                <Select

                  labelId="daysHours-select-label"
                  id="daysHours-select"

                  style={{ height: "35.11px", }}
                  label="Invoice Type"
                  disabled={InvoiceID ? true : false}
                  onChange={handleChange("invoiceType")}
                  value={values.invoiceType}
                  autoFocus={true}
                >
                  <MenuItem value="Direct" >Direct</MenuItem>
                  {/* <MenuItem value="Through Quotation" >Through Quotation</MenuItem> */}
                  <MenuItem value="Through Quotation" >
                    <span style={{
                      width: "100px", whiteSpace: "nowrap",
                      // overflow: "hidden", textOverflow: "ellipsis" 
                    }}>
                      Through Quotation
                    </span>
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={1.5} xs={3}>

              <Autocomplete
                color="info"
                id="quotation-select"
                options={quotationDetails?.length > 0 &&
                  quotationDetails.map(item => ({
                    label: item.quotationNumber,
                    id: item._id
                  }))}
                onChange={handleChangeApprovedQuotation("quotationNumber")}
                isOptionEqualToValue={(option, value) => {
                  if (value === "") { return true; }
                  return option.value === value;
                }}
                value={(values.quotationID && quotationDetails.find(item => item._id === values.quotationID)?.quotationNumber) || ""}
                renderInput={(params) => (
                  <TextField {...params} className="ress" placeholder="Quotation" label="Quotations" autoFocus={true} />
                )}
                disabled={values.invoiceType === "Direct" || InvoiceID}
              />
            </Grid>




            {/* Reference Number */}
            <Grid item lg={1.5} xs={3}>
              <TextField
                type="text"
                label="Reference Number"
                variant="outlined"
                placeholder="Optional"
                fullWidth
                inputProps={{
                  maxLength: 50,
                  className: "custom-fieldtext"
                }}
                disabled={InvoiceID && finalise}
                value={values.purchaseOrderNumber}
                onChange={handleChange('purchaseOrderNumber')}

              />
            </Grid>
            <Grid item lg={1.5} xs={3}>
              <FormControlLabel

                control={
                  <Checkbox
                    checked={values.recurring || false}
                    onChange={(e) => handleChange("recurring")({ target: { value: e.target.checked } })}
                    disabled={finalise}
                  />
                }
                label="Recurring"
              />
            </Grid>

            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  label="Status"
                  value={values.invoiceStatus}
                  disabled
                  onChange={handleChange('invoiceStatus')}
                >
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>

          </Grid>

          {/* {showItemAndDocumentSection && <>
            {(typeQuotation && !InvoiceID) && */}
          {/* <Grid item px={2} pt={1} xs={12} md={4} lg={12} >
            <p style={{ fontSize: "14px", fontWeight: "bold", color: "#1A73E8" }} >Invoice Items</p>
          </Grid> */}
          {/* } */}
          <CardContent sx={tableCardStyle}>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={(typeQuotation && !InvoiceID) ? quotationReadOnlyColumns : columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>

          <Grid container px={2} style={{ marginTop: '10px' }} spacing={2}>

            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Base Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled

                value={formatCurrencyAUD(parseFloat(values.totalAmount).toFixed(2))}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total Discount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                // value={values.totalDiscountAmount}
                onChange={handleChange('totalDiscountAmount')}
                disabled
                value={parseFloat(values.totalDiscountAmount).toFixed(2)}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35px" }}
                  label="GST Type"
                  value={values.gstType || 'Inclusive'}
                  onChange={handleChange('gstType')}
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total GST  (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true, }}
                disabled
                value={formatCurrencyAUD(values.totalGSTAmount)}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Final Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(parseFloat(values.finalAmount).toFixed(2))}
              // autoFocus={true}
              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 100,
                  className: "custom-fieldtext"

                }}
                value={values.paymentInstruction}
                onChange={handleChange('paymentInstruction')}
              // autoFocus={true}
              />
            </Grid>
          </Grid>


          <Grid container pt={2} >

            {InvoiceID &&
              <>
                {(scheduleRetention) ?
                  <Grid container mt={2} columnSpacing={4} alignItems="center" display="flex" justifyContent="center" px={2}>
                    <Grid item xs={12} md={4} spacing={2} lg={6} textAlign={"start"} className="plusButton" >
                      <MDTypography
                        variant="button"
                        fontWeight="bold"
                        color="text"
                        sx={{ userSelect: "none", color: 'red', }}
                      >
                        Retention Limit Amount ({currencyCode + " " + (parseFloat(values.finalAmount) - parseFloat(usedRetentionAmount)).toFixed(2) + " / " + parseFloat(values.finalAmount).toFixed(2)})
                      </MDTypography>
                    </Grid>

                    <Grid item xs={12} md={4} spacing={2} lg={6} textAlign={"end"} className="plusButton" >
                      <MDTypography
                        onClick={addNewRetentionRow}
                        variant="button"
                        fontWeight="bold"
                        color="text"
                        sx={{ cursor: "pointer", userSelect: "none", ml: -1, color: "#1A73E8" }}
                      >
                        <Add /> Add New Row for Retention
                      </MDTypography>
                    </Grid>

                  </Grid>
                  :
                  // <Grid item xs={12} px={2} md={4} lg={2}>
                  //   <Tooltip title="Schedule Retention Link" arrow id="retention" placement="bottom-start">
                  //     <p id="retention" style={{
                  //       fontSize: "14px", fontWeight: "bold",
                  //       color: featureAccess ? "#008000" : "#d3d3d3", textDecoration: "underline", cursor: "pointer"
                  //     }}
                  //       onClick={handleRetentionClick} >
                  //       Schedule Retention
                  //     </p>
                  //   </Tooltip>
                  // </Grid>
                  <Grid item xs={12} px={2} md={4} lg={2}>
                    <Tooltip
                      title="Click to schedule retention"
                      arrow
                      placement="bottom-start"
                    >
                      {/* Old Code Commented by Anuj 17-12-2025  */}
                      {/* <span style={{ cursor: "pointer" }} onClick={handleRetentionClick}>
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: featureAccess ? "#008000" : "#d3d3d3",
                            textDecoration: "underline",
                            margin: 0
                          }}
                        >
                          Schedule Retention
                        </p>
                      </span> */}
                      {/* New Code Created by Anuj 17-12-2025  */}

                      <Box component="span">
                        <Box
                          component="span"
                          onClick={handleRetentionClick}
                          sx={{
                            fontSize: "14px !important",
                            fontWeight: "bold",
                            color: featureAccess ? "#008000" : "#d3d3d3",
                            textDecoration: "underline",
                            cursor: "pointer",        // ✅ always pointer
                            position: "relative",
                            zIndex: 10,
                          }}
                        >
                          Schedule Retention
                        </Box>
                      </Box>
                    </Tooltip>
                  </Grid>

                }
              </>
            }




          </Grid>

          {(scheduleRetention && retentionItemValues.length > 0) &&
            <Grid container pt={2} >
              <CardContent sx={tableCardStyle}>
                <DataTable
                  theme={darkMode ? "solarized" : "light"}
                  columns={columnRetention}
                  data={retentionItemValues}
                  customStyles={customStyles}
                  fixedHeaderScrollHeight="185px"
                  fixedHeader={true}

                />
              </CardContent>
            </Grid>
          }
          {InvoiceID &&
            <Grid container spacing={2}>

              <Grid item xs={12} md={4} lg={12}>
                <Button onClick={() => setExpanded(!expanded)} >
                  <Badge badgeContent={quoDocuments.length} sx={{ ".MuiBadge-badge": { backgroundColor: tableBorder, color: "#ffffff" }, }} showZero>
                    <Typography variant="h6" sx={{ border: darkMode ? "1px solid white" : `1px solid ${tableBorder}`, borderRadius: "5px", color: darkMode ? "white" : tableBorder, display: 'flex', alignItems: 'center', marginLeft: "-9px", padding: "1px 10px", fontSize: "12px" }}>
                      Attached Document
                      {expanded ? <ArrowDropDown className="arrowdropdown" style={{ marginLeft: "5px", }} /> : <ArrowDropUpIcon className="arrowdropdown" style={{ marginLeft: "5px", }} />}
                    </Typography>
                  </Badge>
                </Button>
              </Grid>
            </Grid>
          }
          {expanded && <>

            {(!typeQuotation || InvoiceID) &&
              <>
                <Grid container spacing={2} px={2} pt={2}>
                  {/* <Grid item lg={3} xs={4}>
                      <TextField
                        type="text"
                        label="Document Name"
                        placeholder="Document Name"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 30,
                          className: "custom-fieldtext"
                        }}
                        value={values.documentName}
                        onChange={handleChange('documentName')}
                        disabled
                      // autoFocus={true}
                      />
                    </Grid> */}
                  <Grid item xs={12} lg={4}>
                    <label htmlFor="fileInput">
                      <TextField
                        id="invoiceDocuments"
                        type="text"
                        label="Document File"
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly: true,
                          className: "uploadfile",
                          startAdornment: (
                            <InputAdornment position="start">
                              <label className="ress" htmlFor="fileInput">
                                <Button component="span" size="small" style={{ fontSize: "14px", marginLeft: "-19px", color: `${darkMode ? "white" : tableBorder}`, textDecoration: "2px solid underline" }}
                                // onClick={() => { !values.documentName && (showResMsg(`Please enter Document Name`, 1000, false)) }}
                                >Choose File</Button>

                              </label>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <input
                        type="file"
                        // accept="image/*,.pdf,.docx,.doc,application/vnd.ms-excel,text/csv"
                        id="fileInput"
                        style={{ display: "none" }}
                        // disabled={!values.documentName}
                        onChange={saveFile}
                      />
                    </label>
                    <p style={errMsg}>{fileError}</p>
                  </Grid>
                </Grid>
              </>}

            {quoDocuments.length > 0 &&
              <CardContent sx={tableCardStyle}>
                <DataTable
                  theme={darkMode ? "solarized" : "light"}
                  columns={documentColumns}
                  data={quoDocuments}
                  fixedHeaderScrollHeight="185px"
                  fixedHeader={true}
                  customStyles={customStyles}
                />
              </CardContent>
            }

          </>
          }
          {/* </>
          } */}
          {(showSendEmailBtn && showInvoicePaymentLink) &&
            <Grid item px={2} pt={1} xs={6} md={4} lg={3} >
              <span style={{ fontSize: "14px", fontWeight: "bold", color: "#008000", textDecoration: "underline", cursor: "pointer" }} onClick={handleRedirectToPaymentScreen}>
                Record Part Payment
              </span>

            </Grid>}

          <Grid
            container
            mt={2}
            pb={3}
            // columnSpacing={{ xs: 2, md: 4, lg: 4 }}
            // columnSpacing={4}
            alignItems="center"
            spacing={2}
            style={{ display: "flex", justifyContent: "center" }}
            className="gridbuttons"
          >
            <Grid item xs={12} md={4} lg={1.68}>
              {/* <Link to={routePath}> */}
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ height: "40px" }}
                onClick={handleCancel}
              >
                Close
              </MDButton>
              {/* </Link> */}
            </Grid>
            <Grid item xs={12} md={4}
              lg={1.68}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                style={{ height: "40px" }}
                // disabled={hideUpdateBtn ? quoDocuments.length === 0 : false}
                onClick={handleSaveInvoice}
              // disabled={SCREEN_RIGHT !== "Full Access"}
              >
                {/* {InvoiceID ? (type !== "clone" ? "Save" : "Clone ") : "Save"} */}
                {InvoiceID ? (type !== "clone" ? "Update" : "Clone ") : "Save"}
              </MDButton>
            </Grid>
            {InvoiceID &&
              <Grid item xs={12} md={4} spacing={2} lg={1.68} style={{ cursor: `${showSendEmailBtn ? "pointer" : "not-allowed"}` }}>
                <MDButton
                  rel="noreferrer"
                  variant="gradient"
                  color="info"
                  fullWidth
                  style={{ height: "40px", }}
                  disabled={!showSendEmailBtn}

                  // onClick={handleSaveAndSendToEmail}
                  onClick={handleEmailQuotation}
                // disabled={SCREEN_RIGHT !== "Full Access"}
                >
                  Send Email
                </MDButton>
              </Grid>}

          </Grid>
        </Card>
      </div>

      {viewDocumentInModal && <Modal
        open={viewDocumentInModal}
        onClose={handleCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          '& .MuiModal-root': {
            width: '100%',
            height: '100%',
          },
        }}
      >


        <Card
          sx={darkMode ?
            { ...pdfStyle, border: "none", width: { xs: "95%", sm: "90%", md: "80%" }, maxWidth: "1200px", background: "black" } :
            { ...pdfStyle, border: "none", width: { xs: "95%", sm: "90%", md: "80%" }, maxWidth: "1200px" }
          }
        >
          <Box>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
            >
              Document Viewer
            </Typography>
            <Box sx={{ width: "100%", height: { xs: "60vh", sm: "70vh" }, overflow: "hidden" }}>
              {selectedFileType === "image" ? (
                <img
                  title="Document Viewer"
                  src={getDocumentFileURL}
                  width="100%"
                  height="100%"
                  style={{ display: 'block', objectFit: "contain", aspectRatio: "1/1" }}
                  alt="Document Viewer"
                />
              ) : selectedFileType === "pdf" ? (
                <iframe
                  title="Quotation Document Viewer"
                  src={getDocumentFileURL}
                  width="100%"
                  height="650"
                  allowFullScreen
                ></iframe>
              ) : null}
            </Box>
            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton
                color="warning"
                className="modalButton"
                onClick={() => { setViewDocumentInModal(false) }}
                sx={{ fontSize: "1rem", padding: "0.5rem 1rem" }}
              >
                Close
              </MDButton>
            </Grid>
          </Box>
        </Card>

      </Modal>}
      {showBillingModal && <BillingModal
        open={showBillingModal}
        handleConfirm={() => { navigate('/subscriptions') }}
        handleCancel={() => { setShowBillingModal(false) }}
        closeModalClick={() => { setShowBillingModal(false) }}
        message={genericMessage.billingMsg}
        title={genericMessage.noCreditAvailableTitle}
      />}
      {open && <EmailTemplateModal
        open={open}
        handleClose={handleClose}
        templatesData={templateValues}
        onSend={handleSend}
      />}
      <LoadingModal loading={loading} />
    </DashboardLayout >
  );
}
export default memo(AddInvoice);
